import { render, staticRenderFns } from "./SaldosContas.vue?vue&type=template&id=67d95cee&scoped=true&"
import script from "./SaldosContas.vue?vue&type=script&lang=js&"
export * from "./SaldosContas.vue?vue&type=script&lang=js&"
import style0 from "./SaldosContas.vue?vue&type=style&index=0&id=67d95cee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d95cee",
  null
  
)

export default component.exports